var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[_c('span',{staticClass:"button-title"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"image",attrs:{"src":require("../../assets/images/arrow.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }